import { parsePhoneNumber } from 'libphonenumber-js'

import { isValidEmail, isValidPhoneNumber } from '@cash-web/shared-util-validation'
export interface Alias {
  type: 'phone' | 'email'
  value: string
}

const reformatE164Number = (phoneNumber: string): string => {
  // Afterpay sets the prefilled alias to the E.164 format, so we need to reformat it to the national number format
  // so it's displayed correctly in the alias blocker
  return parsePhoneNumber(phoneNumber, 'US').nationalNumber
}

export const getAlias = (): Alias | null => {
  const passedAlias = window.prefilledAlias
  if (typeof passedAlias !== 'string') {
    return null
  }
  if (isValidPhoneNumber(passedAlias)) {
    return { type: 'phone', value: reformatE164Number(passedAlias) }
  }
  if (isValidEmail(passedAlias)) {
    return { type: 'email', value: passedAlias }
  }
  return null
}

export const clearAlias = () => {
  window.prefilledAlias = undefined
}

export const getLastLoginType = (): 'phone' | 'email' | undefined => {
  return window.lastLoginType
}

export const setLastLoginType = (type: 'phone' | 'email') => {
  window.lastLoginType = type
}
